var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcAppNavigationSettings',{attrs:{"name":_vm.t('collectives', 'Collectives settings')}},[_c('NcTextField',{attrs:{"name":"userFolder","label":_vm.t('collectives', 'Collectives folder'),"label-visible":true,"value":_vm.userFolderValue,"disabled":_vm.disabledPicker},on:{"click":_vm.selectCollectivesFolder}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }